import React, { useContext, useState } from 'react'
import MaskedInput from 'antd-mask-input'
import { Button } from 'antd'
import TextInput from '../TextInput'
import { Patient } from '../../api/patient.types'
import { Man, Woman, Boy, Girl } from '../../images'
import PatientHelper from '../../store/reducks/patients/PatientHelper'
import { BackIcon } from '../../icons'
import config from '../../config'
import { AuthConfigContext } from '../AuthConfigProvider'
import './style.less'
import { TimerText } from '../TimerText'
import { WaitCallError } from '../WaitCallError'

const formatPhone = (value?: any) => {
  value = `${value}`.replace(/[^\d]+/g, '')
  value = value.length > 10 ? value.slice(-10) : value
  return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 8)}-${value.slice(8)}`
}

export type PhoneInputProps = {
  phone: string
  buttonType: 'default' | 'primary'
  buttonText: string
  onPhoneSubmit?: () => void
  buttonDisabled?: boolean
}

export type CodeInputProps = {
  onCodeSubmit?: (code: string) => void
  codeError?: string
}

export type Step2CallProps = {
  waitPhone?: string
  expireAt?: any
}

export type PatientItemProps = {
  patient: Patient
  onSelect?: (patient: Patient) => void
}

export type HeaderProps = {
  title: string
  onBack?: () => void
  className?: string
}

export type Step1Props = {
  phone: string;
  onSubmit?: () => void
  disabled?: boolean
}

export type Step2Props = CodeInputProps & Pick<PhoneInputProps, 'phone' | 'onPhoneSubmit'> & {
  phoneDisabled?: boolean
}

export type Step3Props = {
  patients: Patient[]
  onPatientSelect?: (patient: Patient) => void
}

export type Step1ErrProps = {
  expireAt?: any
  onTimeout?: () => any
  onBack?: () => any
}

class Recovery {
  static Header: React.FC<HeaderProps> = (props) => {
    const { title, onBack, className } = props
    return <div className={`recovery-header ${className || ''}`} onClick={onBack}>
      <div className="back-icon"><BackIcon /></div>
      <div className="title">{title}</div>
    </div>
  }

  static Step1Err: React.FC<Step1ErrProps> = (props) => {
    const { expireAt, onBack, onTimeout } = props
    return <div className='recovery-step1-err'>
      <div className="title no-content">
        <WaitCallError
          expireAt={expireAt}
          onBack={onBack}
          onTimeout={onTimeout}
          hideBackBtn
          text2="Пожалуйста, закройте предыдущую сессию или попробуйте восстановить пароль через"
        />
      </div>
    </div>
  }

  static Step1: React.FC<Step1Props> = (props) => {
    const auth = useContext(AuthConfigContext)
    const isSms = auth.recoveryType === 'sms'
    const buttonText = isSms ? 'Отправить' : 'Продолжить'
    return <div className="recovery-step1">
      <Recovery.Title />
      <div className="content">
        <Recovery.PhoneInput
          phone={props.phone}
          buttonText={buttonText}
          buttonType="primary"
          onPhoneSubmit={props.onSubmit}
          buttonDisabled={props.disabled}
        />
      </div>
    </div>
  }

  static Step2Call: React.FC<Step2CallProps> = (props) => {
    const timer = props.expireAt ? <TimerText expireAt={props.expireAt} /> : '15 мин.'
    const title = <span>
      {'Для получения СМС с логином и паролем необходимо совершить бесплатный (по России) звонок на указанный номер телефона.'}
      <div className='timer'>
        {'Срок действия номера телефона: '}
        {timer}
      </div>
    </span>
    const sub = 'Совершите звонок, используя тот номер, под которым вы зарегистрированы.'
    const step = (
      <div className="wait-call">
        <div className="wait-phone">
          <span>{`8 ${formatPhone(props.waitPhone)}`}</span>
        </div>
        <span className='sub-text'>{sub}</span>
      </div>
    )
    return <div className="recovery-step2">
      <Recovery.Title title={title} />
      <div className="content">
        {step}
      </div>
    </div>
  }


  static Step2: React.FC<Step2Props> = (props) => {
    return <div className="recovery-step2">
      <Recovery.Title />
      <div className="content">
        <Recovery.PhoneInput
          phone={props.phone}
          buttonText="Отправить снова"
          buttonType="default"
          buttonDisabled={props.phoneDisabled}
          onPhoneSubmit={props.onPhoneSubmit}
        />
        <Recovery.CodeInput
          codeError={props.codeError}
          onCodeSubmit={props.onCodeSubmit}
        />
      </div>
    </div>
  }

  static Step3: React.FC<Step3Props> = (props) => {
    const { patients, onPatientSelect } = props
    return <div className="recovery-step3 patients">
      {patients.map((patient, index) => (<Recovery.PatientItem
        key={index}
        patient={patient}
        onSelect={onPatientSelect}
      />))}
    </div>
  }

  static PhoneInput: React.FC<PhoneInputProps> = (props) => {
    const { phone, buttonText, buttonType, onPhoneSubmit: onSubmit, buttonDisabled } = props
    return <div className="phone">
      <MaskedInput
        className="phone-input"
        disabled
        value={phone}
        prefix="+7"
        mask="(111) 111-11-11"
        placeholder="Номер телефона"
        size="large"
      />
      <Button
        className="phone-submit"
        type={buttonType}
        onClick={onSubmit}
        disabled={buttonDisabled}
      >
        {buttonText}
      </Button>
    </div>
  }

  static CodeInput: React.FC<CodeInputProps> = (props) => {
    const [code, setCode] = useState<string>('')
    const { onCodeSubmit: onSubmit, codeError: error } = props
    return <div className="code">
      <TextInput
        className="code-input"
        value={code}
        onChangeText={setCode}
        label="Код из СМС"
        error={Boolean(error)}
        helperText={error ? error : undefined}
      />
      <Button
        type="primary"
        className="code-submit"
        onClick={() => {
          onSubmit && onSubmit(code)
        }}
      >
        {'Продолжить'}
      </Button>
    </div>
  }

  static PatientItem: React.FC<PatientItemProps> = (props) => {
    const { patient, onSelect } = props
    return <div
      className="patient"
      onClick={() => {
        onSelect && onSelect(patient)
      }}
    >
      <div className="avatar">
        <img src={Man} />
      </div>
      <div className="name">
        <span>{PatientHelper.getName(patient)}</span>
      </div>
    </div>
  }

  static Title: React.FC<{ title?: string | JSX.Element }> = (props) => {
    const auth = useContext(AuthConfigContext)
    const isSms = auth?.recoveryType === 'sms'
    const title = isSms
      ? 'Для восстановления пароля вам будет отправлено СМС на следующий номер'
      : 'Для восстановления пароля вам необходимо подтвердить ваш номер телефона'
    return <div className="title">
      <span>
        {props.title || title}
      </span>
    </div>
  }
}

export default Recovery